<template>
	<db-row el="form" class="form-wrapper" height="auto">
		<db-col height="100" valign="middle" v-if="title">
			<db-label class="form-header" bold @click="clickHandler">{{title}}</db-label>
		</db-col>
		<slot></slot>
	</db-row>
</template>

<script>
	export default {
		name: 'form_',
		
		props: {
			title: {
				type: String,
				default: ''
			}
		},
		
		methods: {
			clickHandler(){
				this.$emit('click')
			}
		}
	}
</script>

<style lang="scss" type="text/scss">
	@import '../../../assets/styles/vars.scss';
	
	.form-wrapper{
		padding-left: 24px;
		background: #fff;
		//margin: 20px 0;
		
		.form-header{
			padding-left: 12px;
		}
		
		&:last-child{
			margin-top: 0;
		}
	}
</style>
